'use client'

import { tva } from '@gluestack-ui/nativewind-utils/tva'
import {
  ImageBackground as ExpoImageBackground,
  type ImageBackgroundProps as ExpoImageBackgroundProps
} from 'expo-image'
import { remapProps } from 'nativewind'
import React from 'react'

const imageBackgroundStyle = tva({})

remapProps(ExpoImageBackground, {
  className: 'style',
  imageClassName: 'imageStyle'
})

export type ImageBackgroundProps = ExpoImageBackgroundProps

export const ImageBackground = React.forwardRef<React.ComponentRef<typeof ExpoImageBackground>, ImageBackgroundProps>(
  ({ className, ...props }, ref) => {
    return (
      <ExpoImageBackground
        className={imageBackgroundStyle({
          class: className
        })}
        {...props}
        // @ts-ignore
        ref={ref}
      />
    )
  }
)

ImageBackground.displayName = 'ImageBackground'
